import cover1 from "./cover_1.png";
import cover2 from "./cover_2.png";
import cover3 from "./cover_3.png";
import logoLivre from "./logo-livre.png";
import logoWhiteBaseline from "./memoirs-blanc-baseline.png";
import logoWhite from "./memoirs-blanc.png";
import logoGreyBaseline from "./memoirs-gris-baseline.png";
import logoGrey from "./memoirs-gris.png";
import logoBlackBaseline from "./memoirs-noir-baseline.png";
import logoBlack from "./memoirs-noir.png";
import Upsell from "./upsell.png";

export const logo = {
  logoWhiteBaseline,
  logoBlackBaseline,
  logoGreyBaseline,
  logoWhite,
  logoBlack,
  logoGrey,
};

export const images = {
  logoLivre,
  Upsell,
};

export const covers = {
  cover1,
  cover2,
  cover3,
};
